var exports = {
  "X$": "xe564cbfb--857a4d--pagination",
  "kI": "xe564cbfb--857a4d--pages-list",
  "MY": "xe564cbfb--857a4d--page",
};

module.exports = exports;
